import React, { useEffect, useState } from "react";
import { createClient } from '@supabase/supabase-js';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import a from "../assets/aa.png";

const supabaseUrl = 'https://rarcdrigeqoyrrmdkqfr.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJhcmNkcmlnZXFveXJybWRrcWZyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ0OTA1NjYsImV4cCI6MjA2MDA2NjU2Nn0.4qqE7k7rNl17QQzOetrQiRqy8T-Fl5CMmZXsG90C3-k';


export const supabase = createClient(supabaseUrl, supabaseKey);


  const Main = () => {
  const [propiedades, setPropiedades] = useState([]);

  const getPropiedadesConImagenes = async () => {
    const { data, error } = await supabase
      .from('propiedades')
      .select(`*, imagenes ( imagen_url )`)
      .eq('destacado', true) // ✅ Solo destacadas
      .limit(3); // ✅ Mostramos solo 3

    if (error) {
      console.error('Error cargando propiedades destacadas:', error);
      return [];
    }

    return data;
  };

  useEffect(() => {
    (async () => {
      const props = await getPropiedadesConImagenes();
      setPropiedades(props); // ✅ Ya no hace falta ordenar por ID
    })();
  }, []);

  return (
    <main className="main-container">
      <section
        id="inicio"
        className="hero"
        style={{ backgroundImage: `url(${a})` }}
      >
        <div className="hero-content">
          <h2>
            Somos un Estudio Jurídico Integral e Inmobiliario comprometido en brindar el mejor servicio a nuestros clientes.
          </h2>
          <p>Conoce más sobre nosotros y nuestros servicios.</p>
          <a href="/about" className="btn">Conocer más</a>
        </div>
      </section>

      <div className="propiedades-section" id="propiedades">
        <h2 className="section-title">Publicaciones Destacadas</h2>
        <div className="propiedades-grid">
          {propiedades.length > 0 && propiedades.map(propiedad => (
            <div className="propiedad-card" key={propiedad.id}>
              <div className="propiedad-imagenes">
                <Swiper navigation={true} modules={[Navigation]} className="propiedad-swiper">
                  {propiedad.imagenes.length === 0 ? (
                    <SwiperSlide>
                      <img 
                        src="https://t3.ftcdn.net/jpg/02/68/55/60/360_F_268556012_c1WBaKFN5rjRxR2eyV33znK4qnYeKZjm.jpg" 
                        alt="Propiedad sin imágenes" 
                      />
                    </SwiperSlide>
                  ) : (
                    propiedad.imagenes.map((imagen, idx) => (
                      <SwiperSlide key={idx}>
                        <img src={imagen.imagen_url} alt={`Imagen ${idx + 1}`} />
                      </SwiperSlide>
                    ))
                  )}
                </Swiper>
              </div>
              
              <div className="propiedad-info">
                <h3 className="propiedad-titulo">{propiedad.titulo}</h3>
                <p className="propiedad-direccion">{propiedad.direccion}</p>
                <p className="propiedad-descripcion">{propiedad.descripcion}</p>
                <div className="propiedad-footer">
                  <span className={`propiedad-tipo ${propiedad.type}`}>
                    {propiedad.type === "sale" ? "En Venta" : "En Alquiler"}
                  </span>
                  <button 
                    className="propiedad-btn"
                    onClick={() => window.location.href = '/propiedad/' + propiedad.id}
                  >
                    Ver Propiedad
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <a href="/propiedades" className="btn">Ver todas las propiedades</a>
        </div>
      </div>
    </main>
  );
};

export default Main;